<template>
    <div
        :class="['element-toast-notification', { 'is--active': show }]"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        @mouseover="pauseTimer()"
        @mouseout="startTimer()">
        <svg class="element-icon--featured element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-featured"></use></svg>
        <div class="element-toast-notification__header">
            <p v-if="title" class="element-toast-notification__title">{{ title }}</p>
            <p v-else class="element-toast-notification__title">Notification</p>
            <p class="element-toast-notification__time">{{ timeFormatted }}</p>
        </div>
        <div class="element-toast-notification__body" v-html="body"></div>
        <div class="element-toast-notification__footer">
            <p class="element-toast-notification__countdown" v-if="autoClose">
                Closing in {{ timeToClose }}s
            </p>
            <button v-else
                type="button"
                class="element-button--text element-button"
                data-dismiss="toast"
                aria-label="Close"
                @click.prevent="close()">
                Dismiss
            </button>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

const INTERVAL_TIME = 60

export default {
    props: {
        id: {
            type: String,
            default: _.uniqueId('toast')
        },
        icon: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: 'muted'
        },
        title: {
            type: String,
            default: 'Notice'
        },
        body: {
            type: String
        },
        timestamp: {
            type: Number,
            default: null
        },
        autoClose: {
            type: Boolean,
            default: true
        }
    },
    data () {
        const timeToClose = _.max([50 * this.body.length, 5000])
        return {
            preventAutoClose: false,
            timer: null,
            timeToClose: Math.round(timeToClose / 1000),
            interval: null,
            show: true,
            timeFormatted: ''
        }
    },
    computed: {
        shouldAutoClose () {
            return this.autoClose && !this.preventAutoClose
        }
    },
    methods: {
        startTimer () {
            if (this.shouldAutoClose) {
                window.clearInterval(this.timer)
                this.timer = window.setInterval(() => this.countdown(), 1000)
            }
        },
        pauseTimer () {
            window.clearInterval(this.timer)
        },
        stopTimer () {
            window.clearInterval(this.timer)
            this.preventAutoClose = true
        },
        countdown () {
            if (document.hasFocus()) {
                this.timeToClose--
            }

            if (this.timeToClose <= 0) {
                this.stopTimer()
                this.close()
            }
        },
        close () {
            this.show = false
            _.delay(() => {
                this.$emit('close', this.id)
            }, 500)
        },
        updateTime () {
            if (this.timestamp) {
                this.timeFormatted = moment.unix(this.timestamp).fromNow()
            }
        }
    },
    created () {
        this.updateTime()
        this.startTimer()
        this.interval = window.setInterval(this.updateTime, INTERVAL_TIME * 1000)
    },
    beforeDestroy () {
        this.stopTimer()
        window.clearInterval(this.interval)
    }
}
</script>
